module.exports = __webpack_public_path__ + "img/tuto_mobile_way_01_06.e8a8f29d.png";